import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { startLoading, stopLoading } from '../../../slices/loading.slice';
import { closeModal } from '../../../slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { approveProductApplicationGridView, postProductApplicationGrid, updateProductApplicationGridView } from '../../../slices/productcostapplication.slice';
import { getStorageValue } from '../../../utils/cookies';
import { updatedProductServiceGrid, updateProductServiceGrid } from '../../../slices/serviceagreements.slice';
import '../delete-conformation-modal/delete-conformation-modal.scss'
import { approveCropYearGrid, postCropYearGrid, updateCropYearGrid} from '../../../slices/cropyear.slice';

const ApproveModuleModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { selectedApproveRecord, menuName } = useAppSelector((state) => state.applicationdropdown);
  useEffect(() => {
    dispatch(stopLoading());
  }, [dispatch]);
  const handleCancel = async () => {
    const userId = getStorageValue('user_id') || '';
    if (menuName === 'CropYear') {
      dispatch(postCropYearGrid(Number(userId)))
    }
    else if (menuName === 'ProductCostApplication') {
      dispatch(postProductApplicationGrid(Number(userId)))
    }

    dispatch(closeModal());
  };
  const handleApprove = async () => {
    if (!selectedApproveRecord) {
      toast.error("Invalid item selected");
      return;
    }
    dispatch(startLoading());
    if (menuName === 'CropYear') {
      try {
        dispatch(updateCropYearGrid(selectedApproveRecord))
        const result = await dispatch(approveCropYearGrid(selectedApproveRecord)).unwrap();
        if (result?.message.includes('has been Approved')) {
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }
        dispatch(closeModal());

        const userId = getStorageValue('user_id') || '';
        await dispatch(postCropYearGrid(Number(userId)));
      } catch (error) {
        console.error('Approve failed:', error);
        toast.error("Failed to approve");
      } finally {
        dispatch(stopLoading());
      }
    }

    else if (menuName === 'ServiceAgreements') {
      try {
        const result = await dispatch(updateProductServiceGrid(selectedApproveRecord)).unwrap();
        const updatedRecord = { ...selectedApproveRecord, landlordId: result.landLordId };
        
        await dispatch(updatedProductServiceGrid(updatedRecord)).unwrap();
        dispatch(closeModal());
        
        toast.success("Record has been Successfully Approved");
      } catch (error) {
        console.error('Approve failed:', error);
        toast.error("Failed to approve");
      } finally {
        dispatch(stopLoading());
      }
    }
    
    else {
      dispatch(updateProductApplicationGridView(selectedApproveRecord))
      dispatch(approveProductApplicationGridView(selectedApproveRecord))
        .unwrap()
        .then(() => {
          dispatch(closeModal());
          const userId = getStorageValue('user_id') || '';
          dispatch(postProductApplicationGrid(userId))
          toast.success("Record has been Successfully Approved");
        })
        .catch((error) => {
          console.error('Approve failed:', error);
          toast.error("Failed to approve");
        })
        .finally(() => {
          dispatch(stopLoading());
        });
    }
  };
  return (
    <div className='modal-container'>
      <div>
        <p>Are you sure want to approve the record?</p>
      </div>
      <div className='buttonContainer'>
        <button className='cancelButton' onClick={handleCancel}>Cancel</button>
        <button className='saveButton' onClick={handleApprove} >Approve</button>
      </div>
    </div>
  );
};
export default ApproveModuleModal;